import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {default as moment} from 'moment/moment';
import {IAvailabilityUpdateForm, IAvailabilityUpdateFormData, JobStatuses, NoticePeriods} from '../../shared/interfaces/availability-update';
import {atLeastOneFilledValidator} from '../../shared/validators/at-least-one.validator';
import {AvailabilityService} from '../../shared/services/availability.service';
import {Router} from "@angular/router";


@Component({
  selector: 'availability-update-form',
  templateUrl: './availability-update-form.component.html',
  styleUrls: ['./availability-update-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AvailabilityUpdateFormComponent implements OnInit {
  form: FormGroup<IAvailabilityUpdateForm>;

  public datesValues = {
    minDate: moment.utc(),
    maxDate: moment.utc({ year: 2026, month: 11, day: 31 }),
  };

  public noticePeriods = Object.values(NoticePeriods);

  constructor(private availabilityService: AvailabilityService) {}
  private router = inject(Router);

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
      this.form = new FormGroup<IAvailabilityUpdateForm>({
        jobStatus: new FormControl(null, [Validators.required]),
        lookingForProject: new FormControl(null, [Validators.required]),
        immediate: new FormControl(false),
        specificDate: new FormControl(null),
        noticePeriod: new FormControl(null),
      }, { validators: atLeastOneFilledValidator(['immediate', 'specificDate', 'noticePeriod']) });

      this.form.controls['immediate'].valueChanges.subscribe((val) => {
        console.log('IMMEDIATE CHANGED', val, this.form.value);

        if (val === true) {
          this.form.get('specificDate').disable();
        } else {
          this.form.get('specificDate').enable();
        }
      })
  }

  onSubmit() {
    // this.loading = true;
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      console.warn('Form is invalid', this.form.value, this.form.errors);
      return false;
    }

    this.availabilityService.updateAvailability(this.form.value as IAvailabilityUpdateFormData)
      .subscribe(() => {
          this.router.navigateByUrl('availability/confirmation');
      })
  }

  protected readonly JobStatuses = JobStatuses;
}
